<template>
	<v-form ref="form" v-model="valid" style="height: 100%">
		<v-container fluid :class="loading ? 'fill-height' : ''">
			<v-row
				align="center"
				justify="center"
				v-if="loading"
			>
				<v-col cols="auto">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</v-col>
			</v-row>
			<template v-else>
				<!-- Заголовок -->
				<v-row>
					<v-col cols="auto" :class="['headline', 'pb-0', editMode ? 'pt-1' : 'pt-0']">
						<v-btn
							small
							color="primary"
							@click="back"
						>
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col
						cols="auto"
						v-if="this.mm.status == 0"
						:class="[
							'headline',
							'pr-0',
							'font-weight-light',
							'secondary--text'
						]"
						style="padding-top: 2px;"
					>
						<div class="pt-0">
							[ Черновик ]
						</div>
					</v-col>
					<v-col class="headline" style="padding-top: 2px;">
						<div class="py-0">
							Ведомость мини-макс {{ mm.id > 0 ? '№ ' + mm.id : '' }}
						</div>
					</v-col>
					<v-spacer></v-spacer>
					<v-col class="py-0" cols="auto">
						<v-menu
							v-model="topMenu"
							bottom left
							:close-on-content-click="false"
							v-if="viewMode"
						>
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="d-print-none">
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>

							<v-list class="d-print-none">
								<v-list-item @click="splitOpen" :disabled="mm.lines.length < 2">
									<v-list-item-icon>
										<v-icon style="transform: rotate(90deg)">call_split</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Разделить
									</v-list-item-title>
								</v-list-item>
								<v-list-item @click="print">
									<v-list-item-icon>
										<v-icon>print</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Печать
									</v-list-item-title>
								</v-list-item>
								<v-list-item>
									<v-switch
										v-model="printComments"
										dense
									>
										<template v-slot:label>
											<span class="pl-2">
												Печатать комментарии
											</span>
										</template>
									</v-switch>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-col>
				</v-row>
				<!-- Шапка -->
				<v-row class="body-2">
					<v-col cols="12" sm="4" class="pb-0">
						<v-row>
							<v-col class="py-2">
								MM №
							</v-col>
							<v-col class="py-2">
								<v-chip
									v-if="mm.id > 0"
									small
									label
									color="primary"
								>
									<v-icon small left>list_alt</v-icon>
									{{ mm.id }}
								</v-chip>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Автор
							</v-col>
							<v-col class="py-2">
								{{ mm.authorName }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Дата создания
							</v-col>
							<v-col class="py-2">
								{{ createdDateFormatted }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Изменен
							</v-col>
							<v-col class="py-2">
								{{ mm.updaterName }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Дата обновления
							</v-col>
							<v-col class="py-2">
								{{ updatedDateFormatted }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Склад хранения
							</v-col>
							<v-col class="py-2">
								<template v-if="editMode">
									<v-text-field
										v-model="mm.storage"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!mm.storage && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-text-field>
								</template>
								<template v-else>
									{{ mm.storage }}
								</template>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="5" class="pb-0">
						<v-row>
							<v-col class="py-2">
								Отель
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="mm.hotelCode"
										:items="selectHotel"
										item-text="code"
										item-value="code"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!mm.hotelCode && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-autocomplete>
								</template>
								<template v-else>
									{{ mm.hotelCode }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Отдел
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="mm.dc"
										:items="dcs"
										item-value="code"
										item-text="name"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!mm.dc && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-autocomplete>
								</template>
								<template v-else>
									{{ mm.dcName }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								<v-tooltip
									bottom
									open-delay="300"
								>
									<template v-slot:activator="{ on }">
										<span v-on="on">Актуальность</span>
									</template>
									Кто следит за актуальностью данной ведомости, вносит новые позиции и исключает лишние
								</v-tooltip>
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="mm.respEdit"
										:items="editRoles"
										item-value="code"
										item-text="name"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!mm.respEdit && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-autocomplete>
								</template>
								<template v-else>
									{{ mm.respEditName }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								<v-tooltip
									bottom
									open-delay="300"
								>
									<template v-slot:activator="{ on }">
										<span v-on="on">Пополнение</span>
									</template>
									Кто следит за остатками и инициирует пополнение запасов
								</v-tooltip>
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="mm.respOrder"
										:items="orderRoles"
										item-value="code"
										item-text="name"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!mm.respOrder && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-autocomplete>
								</template>
								<template v-else>
									{{ mm.respOrderName }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="6" class="py-1">
								<v-row>
									<v-col class="py-1">
										Сезонность
									</v-col>
									<v-col v-if="editMode" class="pa-0" cols="auto">
										<v-switch
											v-model="showSeasonality"
											hide-details
											dense
											class="mt-1 py-0"
										></v-switch>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="6" :class="viewMode ? 'py-2' : 'py-1'">
								<v-row class="flex-nowrap">
									<template v-if="editMode && showSeasonality">
										<v-col class="py-0">
											<v-autocomplete
												v-model="mm.seasonFrom"
												:items="months"
												hide-details
												class="body-2 inline"
												:rules="showSeasonality ? [ rules.required ] : []"
											>
												<template v-slot:prepend-inner v-if="showSeasonality && !mm.seasonFrom && showErrors">
													<span class="error--text caption text-no-wrap">Обязательно</span>
												</template>
											</v-autocomplete>
										</v-col>
										<v-col class="py-0 px-0" cols="auto">
											-
										</v-col>
										<v-col class="py-0">
											<v-autocomplete
												v-model="mm.seasonTo"
												:items="months"
												hide-details
												class="body-2 inline"
												:rules="showSeasonality ? [ rules.required ] : []"
											>
												<template v-slot:prepend-inner v-if="showSeasonality && !mm.seasonTo && showErrors">
													<span class="error--text caption text-no-wrap">Обязательно</span>
												</template>
											</v-autocomplete>
										</v-col>
									</template>
									<template v-else>
										<v-col class="py-1">
											{{ seasonalityFormatted }}
										</v-col>
									</template>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="3" class="pb-0">
						<a-status-table
							:steps="mm.steps"
							:status="mm.status"
							:wrapped="$vuetify.breakpoint.xsOnly"
						></a-status-table>
					</v-col>
				</v-row>
				<!-- Получатели -->
				<v-row v-if="viewMode || (mm.dc > 0 && dcs.length > 0)" class="body-2">
					<v-col cols="12" sm="2" class="py-2">
						Получатели
					</v-col>
					<v-col cols="12" sm="7" :class="viewMode ? 'py-2' : 'py-1'">
						<template v-if="editMode">
							<v-autocomplete
								v-model="mm.recipientsBool"
								:items="recipientsItems"
								hide-details
								class="body-2 inline"
							></v-autocomplete>
						</template>
						<template v-else>
							{{ mm.recipientsBool ? 'Другие варианты' : mm.recipientsValue }}
						</template>
					</v-col>
					<v-col v-if="editMode && showRecipients" cols="12" class="py-1">
						<v-textarea
							v-model="mm.recipientsValue"
							hide-details
							auto-grow
							dense
							rows="3"
							class="body-2"
							:rules="[ rules.required ]"
							placeholder="Укажите, кто может получать товары из данной ведомости"
						>
							<template v-slot:prepend-inner v-if="!mm.recipientsValue && showErrors">
								<span class="error--text caption text-no-wrap">Обязательное поле</span>
							</template>
						</v-textarea>
					</v-col>
					<v-col v-else-if="viewMode && showRecipients" cols="12" class="py-2">
						<span v-html="recipientsComputed"></span>
					</v-col>
				</v-row>
				<!-- Таблица -->
				<v-row>
					<v-col class="pt-0">
						<v-data-table
							:headers="computedHeaders"
							:items="computedLines"
							disable-sort
							:items-per-page="-1"
							hide-default-header
							hide-default-footer
							:mobile-breakpoint="0"
							show-expand
							:expanded.sync="expanded"
						>
							<template v-slot:header="{ props: { headers } }">
								<thead>
									<tr>
										<th v-for="h in headers"
											:class="'text-' + h.align"
											:key="h.value"
										>
											<span>
												{{ h.text }}
											</span>
										</th>
									</tr>
								</thead>
							</template>
							<template v-slot:item="{ item }">
								<mm-line
									:ref="'line' + item.num"
									:item.sync="item"
									:edit-mode="editMode"
									:create-mode="createMode"
									:show-errors="showErrors"
									:length="mm.lines.length"
									:expanded="expanded.indexOf(item) > -1"
									@copy="lineCopy"
									@remove="lineRemove"
									@up="lineUp"
									@down="lineDown"
									@expand="expandRow(item)"
									@update:qtyOrder="item.qtyOrder = $event"
								></mm-line>
							</template>
							<template v-slot:expanded-item="{ item }">
								<td colspan="12" class="pa-0">
									<v-card tile>
										<v-container>
											<span class="caption">
												Статистика по закупкам товаров появится после накопления истории транзакций
											</span>
										</v-container>
									</v-card>
								</td>
							</template>
							<template v-slot:body.append="{ headers }">
								<tr>
									<td></td>
									<td class="text-center px-1">
										<v-tooltip
											v-if="editMode"
											bottom
											open-delay="300"
										>
											<template v-slot:activator="{ on }">
												<v-btn
													small
													icon
													v-on="on"
													color="primary"
													@click="lineAdd"
												>
													<v-icon>add</v-icon>
												</v-btn>
											</template>
											Добавить строку
										</v-tooltip>
									</td>
									<td colspan="11"></td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
				<!-- Файлы -->
				<v-row>
					<v-col cols="12">
						<a-file-chips
							:files.sync="files"
							:uploaded-files.sync="mm.files"
							:edit-mode="editMode"
						></a-file-chips>
					</v-col>
				</v-row>

				<!-- Примечания -->
				<v-row>
					<v-col v-if="editMode" cols="12">
						<v-textarea
							v-model="mm.text"
							hide-details
							auto-grow
							dense
							rows="3"
							class="body-2"
							placeholder="Примечания"
						></v-textarea>
					</v-col>
					<v-col v-if="viewMode" cols="12">
						<span class="body-2" v-html="textComputed"></span>
					</v-col>
				</v-row>
				<!-- Кнопки viewMode -->
				<v-row
					v-if="viewMode && !createMode"
					class="d-print-none"
				>
					<v-col cols="auto">
						<div v-intersect="intersectButtons">
							<template
								v-for="button in mm.buttons"
							>
								<v-btn
									v-if="button.visible"
									:key="button.value"
									color="primary"
									class="ma-2"
									:loading="button.loading"
									:disabled="button.disabled"
									@click="actionController(button.value)"
								>
									<v-icon color="green" left v-if="button.value == 'approve'">check_circle</v-icon>
									<v-icon color="white" left v-if="button.value == 'withdraw'">undo</v-icon>
									<v-icon color="deep-orange" left v-if="button.value == 'edit'">edit</v-icon>
									{{ button.text }}
								</v-btn>
							</template>
						</div>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="auto">
						<v-switch
							class="ma-2"
							label="Показать историю редактирования"
							v-model="showChanges"
						></v-switch>
					</v-col>
				</v-row>
				<!-- Кнопка createMode -->
				<v-row
					v-else-if="createMode"
					class="d-print-none"
				>
					<v-col cols="12">
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitCreate"
							v-intersect="intersectButtons"
						>
							Подтвердить
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="cancelCreate"
							v-intersect="intersectButtons"
						>
							Отменить
						</v-btn>
					</v-col>
				</v-row>
				<!-- Кнопки editMode -->
				<v-row
					v-else-if="editMode && mm.status == 0"
					class="d-print-none"
				>
					<v-col cols="12">
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(true)"
							v-intersect="intersectButtons"
						>
							Отправить на утверждение
						</v-btn>
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(false)"
							v-intersect="intersectButtons"
						>
							Сохранить как черновик
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="cancelEditing"
							v-intersect="intersectButtons"
						>
							Отменить
						</v-btn>
					</v-col>
				</v-row>
				<v-row
					v-else-if="editMode && mm.status > 0"
					class="d-print-none"
				>
					<v-col cols="12">
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(false)"
							:loading="loading"
							v-intersect="intersectButtons"
						>
							Готово
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="cancelEditing"
							v-intersect="intersectButtons"
						>
							Отмена
						</v-btn>
					</v-col>
				</v-row>
				<!-- Комментарии -->
				<v-row v-intersect="intersectComments" :class="printComments ? '' : 'd-print-none'">
					<v-col cols="12">
						<a-comments-block
							v-if="mm.id > 0"
							ref="comments"
							type="mm"
							:id="mm.id"
							:changes="showChanges"
							:allow-files="false"
						></a-comments-block>
					</v-col>
				</v-row>

				<v-snackbar
					v-model="snack.info.show"
					:timeout="3000"
					bottom right
				>
					<v-icon
						v-if="snack.info.icon.name.length"
						:color="snack.info.icon.color"
					>
						{{ snack.info.icon.name }}
					</v-icon>
					{{ snack.info.message }}
				</v-snackbar>

				<!-- Диалог split -->
				<v-dialog
					v-model="split.show"
					max-width="1200px"
				>
					<v-card>
						<v-card-title>
							<span class="headline">
								Разделение ведомости
							</span>
						</v-card-title>
						<v-card-text>
							<span class="caption pl-3">
								Выберите строки, которые будут выделены в новую ведомость
							</span>

							<v-data-table
								v-model="split.selected"
								:headers="computedHeaders"
								:items="mm.lines"
								item-key="num"
								show-select
								disable-sort
								:items-per-page="-1"
								hide-default-footer
								@click:row="splitClickRow"
							>
								<template v-slot:header.data-table-select="{ on, props }">
									<!-- <v-checkbox
										hide-details
										class="mt-0"
										color="secondary"
										v-bind="props"
										v-on="on"
									></v-checkbox> -->
								</template>
								<template v-slot:item.data-table-select="{ isSelected, select }">
									<v-checkbox
										hide-details
										class="mt-0"
										color="secondary"
										:value="isSelected"
										@input="select($event)"
									></v-checkbox>
								</template>
								<!-- <template v-slot:item.pr="{ item }">
									<v-chip
										small
										label
										color="primary"
										:to="{ name: 'PrEntry', params: { id : item.requestId } }"
									>
										<v-icon small left>shopping_basket</v-icon>
										{{ item.requestId }}
									</v-chip>
								</template> -->
							</v-data-table>
						</v-card-text>
						<v-card-actions>
							<template>
								<v-btn
									:disabled="split.selected.length == 0 || split.selected.length == mm.lines.length"
									:loading="split.loading"
									text
									@click="makeSplit"
								>
									Разделить
								</v-btn>
								<v-btn
									color="secondary"
									text
									@click="splitClose"
								>
									Отмена
								</v-btn>
							</template>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</template>
		</v-container>
		<!-- Висящие кнопки -->
		<div
			v-if="viewMode && !intersectingButtons && !intersectingComments"
			class="pa-3 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<template
				v-for="button in mm.buttons"
			>
				<v-btn
					v-if="button.visible && button.fixed"
					:key="button.value"
					color="primary"
					class="ma-2"
					:loading="button.loading"
					@click="actionController(button.value)"
				>
					<v-icon color="green" left v-if="button.value == 'approve'">check_circle</v-icon>
					<v-icon color="white" left v-if="button.value == 'withdraw'">undo</v-icon>
					<v-icon color="red" left v-if="button.value == 'reject'">remove_circle</v-icon>
					<v-icon color="blue" left v-if="button.value == 'createOrderPre'">credit_card</v-icon>
					<v-icon color="blue" left v-if="button.value == 'createOrderPost'">credit_card</v-icon>
					<v-icon color="deep-orange" left v-if="
						button.value == 'edit'
						|| button.value == 'editQns'
						|| button.value == 'editIc'"
					>
						edit
					</v-icon>
					{{ button.text }}
				</v-btn>
			</template>

		</div>
		<!-- <div
			v-if="editMode && mm.status > 0 && !intersectingButtons && !intersectingComments"
			class="pa-3 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<v-btn
				color="primary"
				class="ma-2"
				@click="submitEditing(true)"
				v-intersect="intersectButtons"
			>
				Отправить на утверждение
			</v-btn>
			<v-btn
				color="primary"
				class="ma-2"
				@click="submitEditing(false)"
				v-intersect="intersectButtons"
			>
				Сохранить как черновик
			</v-btn>
			<v-btn
				color="secondary"
				class="ma-2"
				@click="cancelEditing"
				v-intersect="intersectButtons"
			>
				Отменить
			</v-btn>
		</div>
		<div
			v-if="editMode && mm.status == 0 && !intersectingButtons && !intersectingComments"
			class="pa-3 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<v-btn
				color="primary"
				class="ma-2"
				@click="submitEditing(false)"
				:loading="loading"
				v-intersect="intersectButtons"
			>
				Готово
			</v-btn>
			<v-btn
				color="secondary"
				class="ma-2"
				@click="cancelEditing"
				v-intersect="intersectButtons"
			>
				Отмена
			</v-btn>
		</div> -->
	</v-form>
</template>

<script>
	import _ from 'lodash'
	import { c } from '../../lib/const'
	import { api } from '../../lib/api'
	import { toNum, toStr, getMonthName, dateFormat, linkify } from '../../js/common'
	import { systemComment, systemIcon } from '../../js/mm.js'
	import aStatusTable from '../base/AStatusTable.vue'
	import aCommentsBlock from '../base/ACommentsBlock.vue'
	import aFileChips from '../base/AFileChips.vue'
	import mmLine from './entry/MmLine.vue'

	var mixinSnack = {
		data: function () {
			return {
				snack: {
					info: {
						show: false,
						message: '',
						icon: {
							name: '',
							color: ''
						},
					},
				},
			}
		},
		methods: {
			showSnackInfo(action) {
				this.snack.info.show = false

				this.snack.info.message = systemComment(action)
				this.snack.info.icon = systemIcon(action)
				this.snack.info.show = true
			},
		}
	}
	var mixinSplit = {
		data: function () {
			return {
				split: {
					show: false,
					selected: [],
					loading: false
				},
			}
		},
		methods: {
			makeSplit() {
				this.split.loading = true
				api.post('mm/split', {
					id: this.mm.id,
					rows: this.split.selected.map(row => row.id)
				})
				.then(response => {
					this.$store.dispatch('dialogNotify', {
						title: 'Ведомость разделена',
						message: 'Создана новая ведомость '
							+ `<router-link :to="{ name: 'MmEntry', params: { id: ${response.data.splitId} } }">`
							+ `${response.data.splitId}`
							+ '</router-link>'
					})
					this.splitClose()
					this.$router.push({ name: 'MmList' })
				}, error => {})
			},
			splitClose() {
				this.split.show = false
				this.split.selected = []
				this.split.loading = false
			},
			splitOpen() {
				this.topMenu = false
				this.split.show = true
			},
			splitClickRow(row) {
				let i = this.split.selected.indexOf(row)
				if (i > -1) {
					this.split.selected.splice(i, 1)
				}
				else {
					this.split.selected.push(row)
				}
			}
		},
	}

	export default {
		mixins: [
			mixinSnack,
			mixinSplit
		],
		components: {
			aStatusTable,
			aCommentsBlock,
			aFileChips,
			mmLine,
		},
		data: () => ({
			createMode: false, // режим создания заявки из этого листа
			dcs: [],
			editMode: false,
			expanded: [],
			files: [],
			filters: [],
			headers: [
				{
					value: 'num',
					text: '№'
				},
				{
					value: 'name',
					text: 'Наименование товаров',
					align: 'center'
				},
				{
					value: 'chars',
					align: 'center',
					text: 'Характеристики / ссылка'
				},
				{
					value: 'unit',
					align: 'center',
					text: 'Ед. изм.'
				},
				{
					value: 'qtyMin',
					text: 'Мин. кол-во',
					align: 'center'
				},
				{
					value: 'qtyMax',
					text: 'Макс. кол-во',
					align: 'center'
				},
				{
					value: 'consumption',
					text: 'Среднемес. расход',
					align: 'center'
				},
				{
					value: 'orderMin',
					text: 'Мин. заказ',
					align: 'center'
				},
				{
					value: 'deliveryTime',
					text: 'Срок поставки',
					align: 'center'
				},
				{
					value: 'shelfLife',
					text: 'Срок хранения',
					align: 'center'
				},
				{
					value: 'priceNetLast',
					text: 'Последняя цена',
					align: 'center'
				},
				{
					value: 'notes',
					text: 'Заметки',
					align: 'center'
				},
				{
					value: 'actions',
					text: '',
					align: 'center'
				},
				{
					value: 'qtyStock',
					text: 'Кол-во на складе',
					align: 'center'
				},
				{
					value: 'qtyOrder',
					text: 'Кол-во в заказ',
					align: 'center'
				},
				{
					value: 'priceNetOrder',
					text: 'Цена без НДС',
					align: 'center'
				},
			],
			intersectingButtons: false,
			intersectingComments: false,
			loading: false,
			mm: {
				id: 0,
				hotelCode: '',
				createdDate: '',
				updatedDate: '',
				author: '',
				respOrder: '',
				respEdit: '',
				respOrderName: '',
				respEditName: '',
				status: 0,
				dc: '',
				dcName: '',
				storage: '',
				steps: [],
				files: [],
				buttons: [],
				lines: [
					{
						active: true,
						num: 1,
						name: '',
						chars: '',
						unit: '',
						qtyMin: '',
						qtyMax: '',
						consumption: '',
						deliveryTime: '',
						orderMin: '',
						shelfLife: '',
						priceNetLast: '',
						notes: '',
					},
				],
				recipientsBool: true,
				recipientsValue: '',
				seasonFrom: 11,
				seasonTo: 2,
				text: ''
			},
			months: [
				{
					value: 1,
					text: 'Январь'
				},
				{
					value: 2,
					text: 'Февраль',
				},
				{
					value: 3,
					text: 'Март',
				},
				{
					value: 4,
					text: 'Апрель',
				},
				{
					value: 5,
					text: 'Май',
				},
				{
					value: 6,
					text: 'Июнь',
				},
				{
					value: 7,
					text: 'Июль',
				},
				{
					value: 8,
					text: 'Август',
				},
				{
					value: 9,
					text: 'Сентябрь',
				},
				{
					value: 10,
					text: 'Октябрь',
				},
				{
					value: 11,
					text: 'Ноябрь',
				},
				{
					value: 12,
					text: 'Декабрь',
				}
			],
			printComments: false,
			rules: {
				required: v => !!v || 'Обязательное поле',
			},
			showAll: false,
			showAllColumns: false,
			showChanges: false,
			showErrors: false,
			showSeasonality: false,
			search: '',
			topMenu: false,
			timer: 0,
			updateInterval: 300000,	// 5 минут
			valid: false,
		}),
		computed: {
			computedHeaders() {
				if (this.editMode) {
					return this.headers.filter(h =>
						h.value !== 'priceNetLast'
						&& h.value !== 'qtyStock'
						&& h.value !== 'qtyOrder'
						&& h.value !== 'priceNetOrder'
					)
				}
				else if (this.createMode) {
					return this.headers.filter(h =>
						h.value === 'num'
						|| h.value === 'name'
						|| h.value === 'unit'
						|| h.value === 'qtyMin'
						|| h.value === 'qtyMax'
						|| h.value === 'qtyStock'
						|| h.value === 'qtyOrder'
						|| h.value === 'priceNetOrder'
					)
				}
				else {
					return this.headers.filter(h =>
						h.value !== 'actions'
						&& h.value !== 'qtyStock'
						&& h.value !== 'qtyOrder'
						&& h.value !== 'priceNetOrder'
					)
				}
			},
			computedLines() {
				return this.mm.lines.filter(h => h.active)
			},
			createdDateFormatted() {
				return dateFormat(this.mm.createdDate)
			},
			dc() {
				return this.mm.dc
			},
			dcNameComputed() {
				let d = this.dcs.find(dc => dc.code == this.mm.dc)
				if (d !== undefined) return d.name
				else return ''
			},
			editRoles() {
				return this.dcs
					.filter(d => this.mm.dc == d.code
						|| d.roleCode == 'HTL_HEAD_PU')
					.map(d => {
						return {
							code: d.roleCode,
							name: d.roleName
						}
					})
			},
			hotelCode() {
				return this.mm.hotelCode
			},
			orderRoles() {
				return this.editRoles
				// return this.dcs
				// 	.filter(d => this.mm.dc.indexOf(d.code) > -1
				// 		|| d.roleCode == 'HTL_HEAD_PU')
				// 	.map(d => {
				// 		return {
				// 			code: d.roleCode,
				// 			name: d.roleName
				// 		}
				// 	})
			},
			recipientsComputed() {
				return linkify(this.mm.recipientsValue.replace(/\n/gi, '<br>'))
			},
			recipientsItems() {
				return [
					{
						value: false,
						text: 'Только ' + this.dcNameComputed
					},
					{
						value: true,
						text: 'Другие варианты'
					}
				]
			},
			seasonalityFormatted() {
				if (this.mm.seasonFrom && this.mm.seasonTo) {
					let from = this.months.find(m => m.value == this.mm.seasonFrom)
					let to = this.months.find(m => m.value == this.mm.seasonTo)

					if (from == undefined || to == undefined) return 'Нет'
					else return from.text + ' - ' + to.text
				}
				else {
					return 'Нет'
				}
			},
			selectHotel() {
				return this.$store.getters.availableHotels
			},
			showRecipients() {
				return this.mm.recipientsBool
			},
			textComputed() {
				return linkify(this.mm.text.replace(/\n/gi, '<br>'))
			},
			updatedDateFormatted() {
				return dateFormat(this.mm.updatedDate)
			},
			viewMode() {
				return !this.editMode
			},
		},
		methods: {
			actionController(value) {
				// console.log('actionController ' + value)
				if (value == 'create') this.create()
				else if (value == 'edit') this.edit()
				else if (value == 'approve') this.approve()
				else if (value == 'withdraw') this.withdraw()
				else if (value == 'drop') this.confirmDrop()
			},
			approve() {
				this.startButtonLoading('approve')

				let params = {
					id: this.mm.id
				}

				api.post('mm/approve', params)
				.then(response => {

					this.stopButtonLoading('approve')
					this.mm.buttons = response.data.buttons
					this.mm.status = response.data.status

					this.loadComments()

					this.showSnackInfo(response.data.sysComment)

					this.$store.dispatch('loadMenuCounters')
				}, error => {
					this.stopButtonLoading('approve')
				})
			},
			back() {
				if (this.search.length || this.filters.length || this.showAll) {
					this.$router.push({
						name: 'MmList',
						params: {
							search: this.search,
							filters: this.filters,
							showAll: this.showAll
						}
					})
				}
				else {
					this.$router.push({
						name: 'MmList'
					})
				}
			},
			cancelCreate() {
				this.createMode = false
			},
			cancelEditing() {
				if (this.mm.id == 0) {
					this.$router.push('/mm')
				}
				else {
					this.files.splice(0, this.files.length)

					this.$refs.form.resetValidation()
					this.showErrors = false

					this.editMode = false

					this.load()
				}
			},
			confirmDrop() {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтвердите сброс согласований',
					message: 'Вы действительно сбросить все согласования?'
				})
				.then(confirm => {
					if (confirm) {
						this.drop()
					}
				})
			},
			create() {
				// console.log('create')
				this.createMode = true
			},
			drop() {
				this.startButtonLoading('drop')

				let params = {
					id: this.mm.id
				}

				api.post('mm/drop', params)
				.then(response => {

					this.stopButtonLoading('drop')
					this.mm.buttons = response.data.buttons
					this.mm.status = response.data.status

					this.loadComments()

					this.showSnackInfo(response.data.sysComment)

					this.$store.dispatch('loadMenuCounters')
				}, error => {
					this.stopButtonLoading('drop')
				})
			},
			edit() {
				this.editMode = true
			},
			expandRow(row) {
				if (this.editMode) return

				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					// this.expanded.push(row)
					this.expanded = [ row ]
				}
			},
			getDcList() {
				// console.log('load dc list')

				api.post('mm/get_depts')
				.then(response => {

					this.dcs = response.data.data

				}, error => {})
			},
			getSteps() {
				// console.log('getSteps')

				var params

				if (this.viewMode) {
					params = {
						id: this.mm.id
					}
				}
				else {
					if (!this.mm.hotelCode) {
						return
					}
					params = {
						hotelCode: this.mm.hotelCode,
						dc: this.mm.dc,
					}
				}

				// console.log('load steps')
				api.post('mm/get_steps', params)
				.then(response => {

					this.mm.steps = response.data.data

				}, error => {})
			},
			intersectButtons(entries, observer) {
				this.intersectingButtons = entries[0].isIntersecting
			},
			intersectComments(entries, observer) {
				this.intersectingComments = entries[0].isIntersecting
			},
			lineCopy(num) {
				let index = this.mm.lines.findIndex(l => l.num == num)
				let copy = _.cloneDeep(this.mm.lines.find(l => l.num == num))
				copy.id = 0
				copy.name = 'Копия ' + copy.name
				copy.stats.last.priceNet = 0
				copy.stats.last.qtyOrdered = 0
				copy.stats.a.priceNet = 0
				copy.stats.a.qtyOrdered = 0
				copy.stats.b.priceNet = 0
				copy.stats.b.qtyOrdered = 0
				copy.stats.c.priceNet = 0
				copy.stats.c.qtyOrdered = 0
				this.mm.lines.splice(index + 1, 0, copy)

				this.linesEnumerate()
			},
			lineAdd() {
				this.mm.lines.push({
					active: true,
					num: this.mm.lines.length + 1,
					name: '',
					chars: '',
					unit: '',
					qtyMin: '',
					qtyMax: '',
					consumption: '',
					deliveryTime: '',
					orderMin: '',
					shelfLife: '',
					priceNetLast: '',
					notes: '',
				})

				this.$refs.form.resetValidation()
			},
			lineRemove(num) {
				this.mm.lines.find(l => l.num == num).active = false
				// this.mm.lines.splice(num - 1, 1)

				this.linesEnumerate()
			},
			lineUp(num) {
				// console.log('lineUp', num)
				let index = this.mm.lines.findIndex(l => l.num == num)
				let copy = this.mm.lines.splice(index, 1)[0]
				this.mm.lines.splice(index - 1, 0, copy)

				this.linesEnumerate()
			},
			lineDown(num) {
				let index = this.mm.lines.findIndex(l => l.num == num)
				let copy = this.mm.lines.splice(index, 1)[0]
				this.mm.lines.splice(index + 1, 0, copy)

				this.linesEnumerate()
			},
			linesEnumerate() {
				let i = 1
				this.mm.lines.forEach(line => {
					if (line.active) {
						line.num = i
						i++
					}
				})
				this.mm.lines.forEach(line => {
					if (!line.active) {
						line.num = i
						i++
					}
				})

			},
			load(loading) {
				let time = new Date
				// console.log(time.toTimeString().substr(0, 8), 'load')

				if (loading === undefined) loading = false

				this.loading = loading

				return api.post('mm/get_entry', {
					id: this.mm.id,
				})
				.then(response => {

					if (this.viewMode) {
						this.mm = response.data.mm

						// this.showRecipients = !!this.mm.recipients
						this.showSeasonality = !!this.mm.seasonFrom || !!this.mm.seasonTo
					}

					this.loading = false

				}, error => {})
			},
			loadComments() {
				if (this.$refs.comments) this.$refs.comments.load()
			},
			merge() {
				this.$router.push({
					name: 'MmList',
					params: {
						initialSelected: this.mm.id
					}
				})
			},
			prepare() {
				// console.log('prepare')

				if (this.mm.id == 'new') {
					this.mm.id = 0
					this.mm.authorName = this.$store.getters.userName
					this.mm.hotelCode = this.$store.getters.selectedHotelCode
					this.mm.status = 0
					this.editMode = true
					this.debouncedGetSteps()

					return true
				}
				else {
					this.mm.id = +this.mm.id
					return this.load(true)
				}
			},
			print() {

				this.$emit('print')
				this.topMenu = false

			},
			startButtonLoading(value) {
				this.mm.buttons.find(b => b.value == value).loading = true
			},
			stopButtonLoading(value) {
				this.mm.buttons.find(b => b.value == value).loading = false
			},
			submitCreate() {
				// console.log('submitCreate')

				let lines = this.computedLines
				.filter(l => toNum(l.qtyOrder) > 0)

				if (lines.length == 0) {
					this.$store.dispatch('dialogNotify', {
						title: 'Не указано количество',
						message: 'Пожалуйста, укажите количество товаров для заказа'
					})
				}
				else {
					this.$router.push({
						name: 'PrEntry',
						params: {
							id: 'new',
							mm: this.mm,
							lines: lines
						}
					})
				}
			},
			submitEditing(approve) {

				if (!this.$refs.form.validate()) {
					this.showErrors = true
					this.$vuetify.goTo(0)
					return
				}

				// console.log('submitEditing')
				this.loading = true

				var formData = new FormData()

				let l = this.files.length
				for (let j = 0; j < l; j++) {
					// console.log(i, j, this.files[i][j])
					formData.append(`files[]`, this.files[j])
				}

				let obj = _.pick(this.mm, [
					'id',
					'hotelCode',
					'respOrder',
					'respEdit',
					'respOrder',
					'dc',
					'files',
					'recipientsBool',
					'recipientsValue',
					'seasonFrom',
					'seasonTo',
					'text',
					'storage'
				])

				obj.lines = []

				this.mm.lines.forEach(line => {
					obj.lines.push(_.pick(line, [
						'id',
						'active',
						'num',
						'name',
						'chars',
						'unit',
						'qtyMin',
						'qtyMax',
						'consumption',
						'deliveryTime',
						'orderMin',
						'shelfLife',
						'notes'
					]))
				})

				// console.log(obj)

				formData.append('form', JSON.stringify({
					mm: obj,
					approve: approve
				}))

				api.post('mm/change', formData)
				.then(response => {
					this.editMode = false

					if (this.mm.id == 0) {
						this.$router.push({ path: '/mm/' + response.data.id })
					}
					else {
						this.mm.buttons = response.data.buttons
						this.mm.status = response.data.status

						this.files.splice(0, this.files.length)

						if (response.data.files) {
							this.mm.files = response.data.files
						}
					}

					this.loading = false

				}, error => {
					this.loading = false
				})
			},
			toStr(val) {
				return toStr(val)
			},
			withdraw() {
				this.startButtonLoading('withdraw')
				api.post('mm/withdraw', {
					id: this.mm.id,
				})
				.then(response => {

					this.stopButtonLoading('withdraw')
					this.mm.buttons = response.data.buttons
					this.mm.status = response.data.status

					this.loadComments()

					this.showSnackInfo(response.data.sysComment)

					this.$store.dispatch('loadMenuCounters')
				}, error => {
					this.stopButtonLoading('withdraw')
				})
			},
		},
		created() {
			this.debouncedGetSteps = _.debounce(this.getSteps, 1000, { leading: false })
			this.throttledLoad = _.throttle(this.load, 10000)
			this.throttledLoadComments = _.throttle(this.loadComments, 10000)
			this.debouncedGetDcList = _.debounce(this.getDcList, 2000, { leading: false })
		},
		watch: {
			editMode(val, old) {
				if (val) {
					// console.log('watcher - editMode', old, '=>', val)
					if (this.dcs.length <= 1) {
						this.debouncedGetDcList()
					}
					if (this.mm.seasonFrom.length && this.mm.seasonTo.length) {
						this.showSeasonality = true
					}
				}
			},
			dc(val, old) {
				if (!_.isEqual(val, old) && this.editMode) {
					// console.log('watcher - dc', old, '=>', val)
					this.debouncedGetSteps()
				}
			},
			hotelCode(val, old) {
				if (!_.isEqual(val, old) && this.editMode) {
					// console.log('watcher - hotelCode', old, '=>', val)
					this.debouncedGetSteps()
				}
			},
			showSeasonality(val, old) {
				if (!val && this.editMode) {
					this.mm.seasonFrom = ''
					this.mm.seasonTo = ''
				}
			},
			showRecipients(val, old) {
				if (this.editMode) {
					if (!val) {
						this.mm.recipientsValue = 'Только ' + this.dcNameComputed
					}
					else {
						this.mm.recipientsValue = ''
					}
				}
			},
		},
		mounted() {
			this.mm.id = this.$route.params.id

			if (this.$route.params.search !== undefined) this.search = this.$route.params.search
			if (this.$route.params.filters !== undefined) this.filters = this.$route.params.filters
			if (this.$route.params.showAll !== undefined) this.showAll = this.$route.params.showAll

			this.prepare()

			this.timer = setInterval(() => {
				if (!document.hidden) {
					if (this.viewMode) {
						this.throttledLoad()
					}
					this.throttledLoadComments()
				}
			}, this.updateInterval)

			window.onfocus = () => {
				// console.log('onfocus')
				if (this.viewMode) {
					this.throttledLoad()
				}
				this.throttledLoadComments()
			}
		},
		destroyed() {
			clearInterval(this.timer)
			window.onfocus = null
		},
		beforeRouteUpdate (to, from, next) {
			if (to.params.id != 'new') {
				if (this.editMode) {
					this.editMode = false
					var editMode = true
				}

				this.mm.id = to.params.id

				this.prepare().then(response => {
					if (editMode) this.editMode = true
				})

				next()
			}
		},
}
</script>

<style scoped>
	.inline {
		margin: 0px;
		padding: 0px;
	}
	::v-deep .inline textarea,
	::v-deep .inline input,
	::v-deep .inline .v-input__append-inner {
		margin: 0px;
		padding: 0px;
	}
</style>